import { IFacetResult } from './facets';

export interface ISearchResult {
    title: string;
    url: string;
    publishDate: Date;
    shortDescription: string;
    friendlyUrl: string;
    metaData: any;
    hitId: any;
    hitType: string;
    trackId: any;
    contexts: string[];
    volumeNumber: string;
    pageNumbers: string;
	issueNumber: string;
	publicationName: string;
	itemRetailPrice: string;
    itemMemberPrice: string;
    resultType: string;
	imageUrl: string;
    tags: string[];
    iconType: string;
    isBestBet: boolean;
    bookSections: string[];
    bookChapter: string;
    email: string;
    phoneNumber: string;
    address: string;
    practiceUrl: string;
    designation: string;
    boardCertificationNames: string[];    
    isFaap: boolean;
    subSpecialties: string[];
    medicalSpecialties: string[];
    policyTopics: string[];
    pocTags: string[];
    automaticLandingPageImage: string;
    productCode: string;
    productType: number;
    itemNumber: string;
    categories: string[];
}

export interface IResults {
    loading: boolean;
    currentPage: number;
    searchItemList: ISearchResult[];
    facets: IFacetResult[];
    totalNumber: number;
    totalPages: number;
    errorMessage: string;
    errorType: IErrorType;
    showResults: boolean;
    trackingId: string;
    suggestion: string;
    fromAutocomplete: boolean;          // If the search term was from an autocomplete suggestion
}

export enum IErrorType {
    NONE,
    GENERAL,
    TIME_OUT,
    UNAUTHORIZED
}